import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps'
import { mapProps } from 'recompose'

import { resultItem } from '../utils/propTypes'

import BudgetRating from './BudgetRating'

const minProp = (prop) => (value, item) => {
  if (item[prop] < value) {
    return item[prop]
  }

  return value
}

const maxProp = (prop) => (value, item) => {
  if (item[prop] > value) {
    return item[prop]
  }

  return value
}

// TODO: see whether the InfoWindow bug continues. If so, remove the `&use_slippy=true` from the URL below.
// (The bug is that, sometimes (most of the time?), a no-content InfoWindow appears when a normal one does too.)

@mapProps(({ googleApiKey, ...restProps }) => ({
  ...restProps,
  googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.31&key=${googleApiKey}&libraries=geometry,places&use_slippy=true`,
  loadingElement: <div style={{ height: '100%' }} />,
  containerElement: <div style={{ height: '100%' }} />,
  mapElement: <div style={{ height: '100%' }} />,
}))
@withScriptjs
@withGoogleMap
export default class VenueProposalMap extends Component {
  static propTypes = {
    activeProperty: PropTypes.string,
    map: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    results: PropTypes.arrayOf(resultItem).isRequired,
  }

  state = {
    selectedResult: null,
  }

  componentDidMount () {
    this.fitMapToResults(this.props)
  }

  componentWillReceiveProps (nextProps) {
    // If either the results of the map lat/lng have changed, update the map location
    if (nextProps.results !== this.props.results || nextProps.map !== this.props.map) {
      this.fitMapToResults(nextProps)
    }
  }



  fitMapToResults (props) {
    if (this.map) {
      const { results, map: { lat, lng } } = props

      if (results && results.length > 2) {
        const latLngBounds = {
          east: results.reduce(maxProp('lng'), lng),
          west: results.reduce(minProp('lng'), lng),
          north: results.reduce(maxProp('lat'), lat),
          south: results.reduce(minProp('lat'), lat),
        }

        this.map.fitBounds(latLngBounds)
      }
    }
  }

  storeMap = (ref) => this.map = ref

  selectResultFactory = (result) => () => this.setState({ selectedResult: result })
  deselectResult = () => this.setState({ selectedResult: null })

  render () {
    const { map, results } = this.props
    const { selectedResult } = this.state

    return (
      <GoogleMap
        zoom={12}
        defaultCenter={map}
        onClick={this.deselectResult}
        ref={this.storeMap}
      >
        {results.map((item) => {
          let icon = '/static/svg/map-marker.svg'
          let zIndex = 1

          if (this.props.activeProperty === item.uuid) {
            zIndex = 3

            if (item.wishlisted) {
              // wishlisted and hovering
              icon = '/static/svg/map-marker--wishlist-hover.svg'
            } else {
              // just hovering
              icon = '/static/svg/map-marker-hover.svg'
            }
          } else {
            if (item.wishlisted) {
              // just wishlisted
              icon = '/static/svg/map-marker--wishlist.svg'
              zIndex = 2
            }
          }

          return (
            <Marker
              key={item.uuid}
              icon={icon}
              onClick={this.selectResultFactory(item.uuid)}
              options={{
                optimized: false,
                zIndex,
              }}
              position={{ lat: item.lat, lng: item.lng }}
            >
              {(selectedResult === item.uuid) && (
                <InfoWindow onCloseClick={this.deselectResult}>
                  <div className='map-info-window'>
                    <img className='map-info-window__image' src={item.images[0]} />
                    <p className='text-strong'>{item.title}</p>

                    <a href={item.url} className='btn btn--primary btn--small btn--outline btn--full-width'>View space</a>
                  </div>
                </InfoWindow>
              )}
            </Marker>
          )
        })}
      </GoogleMap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VenueProposalMap.js